// extracted by mini-css-extract-plugin
export default {"label-row":"styles_label-row__EiJOZ","label-field":"styles_label-field__V7d80"};